import { ROLE_ACCESS } from '@/constant/storage';
import useHideHeaderInPostDetail from '@/hooks/post/useHideHeaderInPostDetail';
import usePostGroupRole from '@/hooks/post/usePostGroupRole';
import { useScreen } from '@/hooks/useScreen';
import { IPost } from '@/interfaces/post.interface';
import { FolderStatusEnum } from '@/interfaces/training.interface';
import { Slide } from '@mui/material';
import { checkIsUserJoined } from 'common/checkRoleUser';
import { newTimeStamp } from 'common/timestamp';
import { PostContext } from 'context/PostContext';
import DataChips from 'design-system/components/Chips/DataChips';
import { EChipType } from 'design-system/components/Chips/types';
import Icon from 'design-system/components/Icon/Icon';
import Tooltips from 'design-system/components/Tooltips/Tooltips';
import Typography from 'design-system/components/Typography/Typography';
import { PropsWithChildren, useContext } from 'react';
import PostBody from '../PostBody';
import PostCommentSection from '../PostCommentSection';
import PostInteractionProvider from '../provider/PostInteractionProvider';
import PostProvider from '../provider/PostProvider';
import FloatingPostInteractionMenu from './FloatingPostInteractionMenu';
import NewPostHead from './NewPostHead';
import NewPostUploadSection from './NewPostUploadSecion';

const NewPost = ({ ...postInfo }: IPost) => {
  return (
    <PostProvider postInfo={postInfo}>
      <PostInteractionProvider>
        <Wrapper>
          <div className="px-2 xl:px-6">
            <PostBody />
          </div>
          <div className="px-2 xl:px-6" id="comment_section">
            <NewPostUploadSection />
            <NewPostFooter />
          </div>
        </Wrapper>
      </PostInteractionProvider>
    </PostProvider>
  );
};

function NewPostFooter() {
  const { group, postId, isOwner } = useContext(PostContext);

  const { data: userRole } = usePostGroupRole({
    groupId: group?.groupId,
    postId,
  });

  return checkIsUserJoined(userRole as ROLE_ACCESS) ||
    group?.status === FolderStatusEnum.Public ||
    isOwner ||
    !group ? ( //this means this post is posted on user's wall
    <PostCommentSection openCommentSection={true} />
  ) : (
    <></>
  );
}

function Wrapper(props: PropsWithChildren<{}>) {
  const { createdAt, readingTime } = useContext(PostContext);

  const { isDesktop } = useScreen();

  const show = useHideHeaderInPostDetail();

  return (
    <>
      {isDesktop ? (
        <FloatingPostInteractionMenu />
      ) : (
        <Slide direction="up" in={show} mountOnEnter unmountOnExit>
          <FloatingPostInteractionMenu />
        </Slide>
      )}
      {/* 56px for FloatingPostInteractionMenu, 32px for flex-gap, 273px for recommend courses on right-side */}
      <div className="h-fit flex-1 rounded-[10px] bg-white xl:max-w-[calc(100%-56px-273px-32px)]">
        <Slide direction="down" in={show}>
          <NewPostHead />
        </Slide>
        <div className="mb-2 mt-2 flex items-center justify-between px-2 xl:mb-6 xl:px-6">
          <Tooltips title={'Thời gian đọc dự kiến'}>
            <div>
              <DataChips
                variant={EChipType.Action}
                startIcon={<Icon iconName={'clock'} />}
              >
                {readingTime} phút đọc
              </DataChips>
            </div>
          </Tooltips>
          <Typography variant={'input-label'} className="text-Action/Active">
            {newTimeStamp(createdAt)}
          </Typography>
        </div>
        {props.children}
      </div>
    </>
  );
}

export default NewPost;
